import { RouteConfig } from 'vue-router';
import ResourceCreate from '@/components/Common/ResourceCreate.vue';
import { Permissions } from '@/types';

const NetworkList = () =>
  import(/* webpackChunkName: "network-routes" */ '@/components/Networks/NetworkList.vue');
const NetworkCreate = () =>
  import(/* webpackChunkName: "network-routes" */ '@/components/Networks/NetworkCreate.vue');
const NetworkEdit = () =>
  import(/* webpackChunkName: "network-routes" */ '@/components/Networks/NetworkEdit.vue');

const routes: RouteConfig[] = [
  {
    path: 'networks',
    name: 'networks',
    components: {
      default: NetworkList,
      pageActions: ResourceCreate
    },
    props: {
      pageActions: {
        text: 'Add Network'
      }
    },
    meta: {
      pageTitle: 'Networks',
      permission: Permissions.QUERY_NETWORKS
    }
  },
  {
    path: 'networks/create',
    name: 'networks-create',
    components: {
      default: NetworkCreate
    },
    meta: {
      pageTitle: 'Create Network',
      showBackButton: true,
      permission: Permissions.CREATE_NETWORK
    }
  },
  {
    path: 'networks/:id(\\d+)/edit',
    name: 'networks-edit',
    components: {
      default: NetworkEdit
    },
    props: {
      default: (route: any) => ({
        networkId: parseInt(route.params.id)
      })
    },
    meta: {
      pageTitle: 'Edit Network',
      showBackButton: true,
      permission: Permissions.UPDATE_NETWORK
    }
  }
];

export default routes;
